import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type { IBrandOverviewResponse } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/brand-overview/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

export const useBrandOverviewData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<IBrandOverviewResponse> =>
    useLLMReportQuery<IBrandOverviewResponse, ILLMWidgetRequestParams>(
        "brandOverview",
        apiClient.AiTracker.aiTrackerReportsBrandVisibilityReportBrandVisibilityOverviewList,
        params,
        options,
    );
